import { FC, useState } from 'react';

import StatPageSideBar from '@shared/components/StatPageSideBar';

import { useTitleHook } from '../../bugo/hooks/useTitleHook';

/**
 * TODO: 답례품 정산 관리 페이지 구현 (bugo-brand / 상조 관점)
 * 보는 user: agencyAdmin
 * 1. 쿠폰형 | 배송형 정산 분리 (탭)
 * 2. 현재는 배송형만 개발 필요
 * 3. 배송형 탭 기준 (giftDelivery)
 *  -> 상조 관점에서는 업체정산은 불필요. 해당 bugoBrand가 "받을 돈"(상조 정산)만 확인
 *  -> 배송완료된 내역 중 정산이 되지 않은 건에 대한 표시 (받을 정산 예정 내역)
 *  -> 정산 완료된 내역에 대한 표시 (언제 정산받았는지)
 *
 * api 설명
 *  배송형 기준 giftDelivery 조회
 *  상조정산은 gift-rebate-settlement
 * *
 * bugoBrand가 받을 돈 계산 방식
 * delivery에 연결된 giftOrder의 orderDetails 의 giftItem으로 _id 비교시 찾을 수 있는것에 매출정보가 있음 (priceRetail)
 * 해당 가격의 5.3%가 우리 수수료
 * 상조수익금 = 해당 가격 - 5.3% 수수료 - priceWhole(giftItem의) = 상조가 보는 도매가 * quantity (단 여기서 giftItemBrand의 settlementInfo에서 shippingFee는 계산이 되어야함 택배비는 포함 x)
 * giftItemBrand의 settlementInfo에서 shippingFee는 계산이 되어야함 택배비는 포함 x
 *  */

type SettlementTab = 'coupon' | 'delivery';

const TABS: { key: SettlementTab; label: string }[] = [
  { key: 'coupon', label: '쿠폰형' },
  { key: 'delivery', label: '배송형' },
];

const AgencyAdminGiftSettlementContent: FC = function AgencyAdminGiftSettlementContent() {
  useTitleHook('답례품 정산');
  const [tab, setTab] = useState<SettlementTab>('delivery');

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      {/* 헤더 */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">답례품 정산</h1>
        <p className="mt-1 text-sm text-gray-500">
          쿠폰형 / 배송형 정산 내역 조회 및 관리
        </p>
      </div>

      {/* 탭 */}
      <div className="mb-6 border-b border-gray-200">
        <nav className="-mb-px flex gap-4">
          {TABS.map((item) => (
            <button
              key={item.key}
              onClick={() => setTab(item.key)}
              className={`whitespace-nowrap border-b-2 px-1 py-3 text-sm font-medium ${
                tab === item.key
                  ? 'border-indigo-600 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              }`}
            >
              {item.label}
            </button>
          ))}
        </nav>
      </div>

      {/* 탭 콘텐츠 (placeholder) */}
      {tab === 'coupon' && (
        <div className="rounded-lg bg-white p-6 shadow">
          <h2 className="mb-4 text-lg font-bold text-gray-800">쿠폰형 정산</h2>
          <div className="flex min-h-[240px] items-center justify-center text-sm text-gray-400">
            쿠폰형 정산 영역 (구현 예정)
          </div>
        </div>
      )}

      {tab === 'delivery' && (
        <div className="space-y-6">
          {/* 받을 정산 예정 내역 (placeholder) */}
          <div className="rounded-lg bg-white p-6 shadow">
            <h2 className="mb-4 text-lg font-bold text-gray-800">
              받을 정산 예정 내역 (배송완료 · 미정산)
            </h2>
            <div className="flex min-h-[160px] items-center justify-center text-sm text-gray-400">
              해당 상조가 받을 정산 대상 내역 (구현 예정)
            </div>
          </div>

          {/* 정산 완료 내역 (placeholder) */}
          <div className="rounded-lg bg-white p-6 shadow">
            <h2 className="mb-4 text-lg font-bold text-gray-800">정산 완료 내역</h2>
            <div className="flex min-h-[160px] items-center justify-center text-sm text-gray-400">
              정산받은 내역 (언제 정산받았는지) (구현 예정)
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export const AgencyAdminGiftSettlementPage: FC = () => (
  <div className="flex">
    <div className="flex flex-col">
      <StatPageSideBar />
    </div>
    <div className="mx-auto max-w-screen-2xl flex-1">
      <div className="px-10 py-8">
        <AgencyAdminGiftSettlementContent />
      </div>
    </div>
  </div>
);
